import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import Booking from './Booking'
import Footer from './Footer'
import Clients from './Clients'

import { GiTicket } from "react-icons/gi";
import { FaChartLine,FaPlug,FaAngry,FaStar,FaCogs,FaUserTag } from "react-icons/fa";

import fs from '../../TicketingImage/ticketingoverview.png';
import an from '../../TicketingImage/analytics.jpeg';

import ci from '../../TicketingImage/customintegration.png';
import cc from '../../TicketingImage/customercomplaints.jpeg';
import km from '../../TicketingImage/kmmanagement.png';
import rs from '../../TicketingImage/reviews&feedback.jpeg';
import ta from '../../TicketingImage/ticketautomation.jpeg';
import { useNavigate } from 'react-router-dom'



function Support() {
  const navigate = useNavigate();
  const analyticsData = [
    {
      icon: <FaChartLine />,
      iconTitle: 'Analytics',
      image: an,
      title: 'Utilize analytics to make informed decisions and improve ticketing efficiency.',
      lines: [
        'Track and analyze ticket resolution times and customer satisfaction.',
        'Identify areas for improvement in the ticketing process.',
        'Make data-driven decisions to enhance customer support.'
      ],
    },
  ];
  const customIntegrationData = [
    {
      icon: <FaPlug />,
      iconTitle: 'Custom Integration',
      image: ci,

      title: 'Integrate ticketing management with custom solutions for enhanced functionality.',
      lines: [
        'Seamlessly connect ticketing data with other business applications.',
        'Implement custom integrations for a tailored ticketing system.',
        'Optimize workflow by integrating ticketing with your existing tools.'
      ],
    },
  ];
  const customerComplaintsData = [
    {
      icon: <FaAngry />,
      iconTitle: 'Customer Complaints',
      image: cc,
      title: 'Efficiently handle and resolve customer complaints through the ticketing system.',
      lines: [
        'Centralized platform for managing and addressing customer complaints.',
        'Streamline communication and resolutions to improve customer satisfaction.',
        'Track and analyze complaint resolution metrics for continuous improvement.'
      ],
    },
  ];
  const reviewsFeedbacksData = [
    {
      icon: <FaStar />,
      iconTitle: 'Reviews & Feedbacks',
      image: rs,
      title: 'Collect and analyze customer reviews and feedback through the ticketing system.',
      lines: [
        'Centralized repository for customer reviews and feedback.',
        'Gather insights to improve products, services, and customer support.',
        'Implement changes based on customer feedback for continuous enhancement.'
      ],
    },
  ];
  const ticketAutomationData = [
    {
      icon: <FaCogs />,
      iconTitle: 'Ticket Automation',
      image: ta,
      title: 'Automate routine tasks and processes to streamline ticket resolution.',
      lines: [
        'Implement automation for ticket categorization and assignment.',
        'Automate responses and updates to keep customers informed.',
        'Increase efficiency and reduce manual intervention in the ticketing system.'
      ],
    },
  ];
  const dedicatedKMAssignmentData = [
    {
      icon: <FaUserTag />,
      iconTitle: 'Dedicated KM Assignment',
      image: km,
      title: 'Assign dedicated Knowledge Management resources for efficient ticket resolution.',
      lines: [
        'Assign specific team members for handling Knowledge Management tasks.',
        'Improve resolution times by leveraging specialized knowledge.',
        'Enhance team collaboration and knowledge-sharing for better support.'
      ],
    },
  ];
  
  
  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <GiTicket  className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Ticketing Management</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>Redefining Customer Support Excellence</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '> Gain insights into ticketing efficiency through analytics, seamlessly integrate with custom solutions, and handle customer complaints with precision. Streamline support operations, optimize ticket resolution, and enhance customer satisfaction.
        </span>
        
            
            <button onClick={() => navigate('/waitlist')}  className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className='  w-full lg:w-[50%]'>
     <img className=' aspect-auto' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

        {/* 3rd Section */}
        {/* <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center">       
<span className='bold text-center  text-[20px] sm:text-[24px] lg:text-[30px]'>Why does business management matter?</span>
<div className=' flex flex-wrap xl:flex-nowrap gap-4 justify-evenly w-full'>
 {reviewCard?.map((e) => (
    <div className="w-[380px] h-[400px] border rounded-[30px] shadow-md bg-[#fafafa] flex flex-col gap-5 p-6">
    <span className="text-2xl xl:text-3xl 2xl:text-5xl text-blue-700"> {e.icon}</span>
    <span className='bold text-[17px] xl:text-[20px]  '>{e.title}</span>    
        
         <span className='regular text-sm lg:text-base leading-[25px] lg:leading-[30px] break-words  '>{e.sub}</span>
    </div>
 ))}
   

</div>
</div> */}
  {/* 4th Section */}
  <PageSection bg  data={analyticsData} />

  <PageSection reverse  data={customIntegrationData} />
  {/* <Clients /> */}

  <PageSection bg data={customerComplaintsData} />

  <PageSection reverse  data={reviewsFeedbacksData} />

  <PageSection bg  data={ticketAutomationData} />

  <PageSection reverse  data={dedicatedKMAssignmentData} />



  <Branding />


  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default Support
